<template>
  <global-modal name="event-modal-change-company" v-if="event">
    <Modal @close="closePopupHandler">
      <div class="change-company">
        <div class="change-company__header">
          <div class="change-company__header-top change-company_container">
            <h1 class="change-company__header-top-title">
              {{ $t("event.changeCompany.popupTitle") }}
            </h1>
            <p class="change-company__header-top-all">
              {{
                $t("event.changeCompany.modal.totalCompanies", {
                  amount: companies.length
                })
              }}

              {{
                companies.length
                  | pluralize($t("event.changeCompany.pluralize"))
              }}
            </p>
          </div>

          <div
            class="change-company__header-bot change-company_container"
            v-if="companies.length"
          >
            <SearchField
              :placeholder="$t('event.changeCompany.modal.searchPlaceholder')"
              v-model="searchText"
            />

            <div class="change-company__header-bot-show">
              <LinkIcon
                @click="view = 'table'"
                icon="list-show-grey"
                :bold="true"
                :grey="view !== 'table'"
                :darkBlue="view === 'table'"
              >
                {{ $t("event.changeCompany.modal.viewByList") }}
              </LinkIcon>

              <LinkIcon
                @click="view = 'card'"
                icon="card"
                :bold="true"
                :grey="view !== 'card'"
                :darkBlue="view === 'card'"
              >
                {{ $t("event.changeCompany.modal.viewByCards") }}
              </LinkIcon>
            </div>
          </div>

          <div class="change-company_container" v-if="filteredCompanies.length">
            <EventModalChangeCompanyCard
              v-if="view === 'card'"
              :companies="filteredCompanies"
            />

            <EventModalChangeCompanyTable
              v-if="view === 'table'"
              :companies="filteredCompanies"
            />
            <span> </span>
          </div>
        </div>
      </div>
    </Modal>
  </global-modal>
</template>

<script>
import { mapState } from "vuex";
import Modal from "@/components/Modal/Modal.vue";
import { LinkIcon, SearchField } from "@v2/shared/ui/components";
import { i18n } from "@v2/shared/config";
import EventModalChangeCompanyCard from "./EventModalChangeCompanyCard.vue";
import EventModalChangeCompanyTable from "./EventModalChangeCompanyTable.vue";

export default {
  name: "EventModalChangeCompany",

  components: {
    Modal,
    LinkIcon,
    SearchField,
    EventModalChangeCompanyCard,
    EventModalChangeCompanyTable
  },

  computed: {
    ...mapState("event", ["event", "companies"]),

    locale() {
      return i18n.locale;
    },

    filteredCompanies() {
      if (!this.searchText) {
        return this.companies;
      }

      return this.companies.filter(el => {
        const names = {
          name_rus: el.company.name_rus
            ? el.company.name_rus.toLowerCase()
            : "",
          name_eng: el.company.name_eng ? el.company.name_eng.toLowerCase() : ""
        };
        const test = str => {
          const r = new RegExp(this.searchText.toLowerCase(), "gi");
          return str.match(r);
        };
        return this.locale === "ru"
          ? test(names.name_rus)
          : test(names.name_eng);
      });
    }
  },

  data() {
    return {
      view: "table",
      searchText: ""
    };
  },

  methods: {
    closePopupHandler() {
      this.$modal.hide("event-modal-change-company");
      this.searchText = "";
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.change-company {
  padding: 56px 0 64px 0;

  @include respond-down(lg) {
    padding: 48px 0 64px 0;
  }

  @include respond-down(md) {
    padding: 24px 16px 32px 16px;
  }

  &__header {
    &-top {
      display: flex;
      justify-content: space-between;
      align-items: center;

      @include respond-down(md) {
        flex-direction: column;
        align-items: flex-start;
      }

      &-title {
        @include h1();
      }

      &-all {
        margin: 10px 0 0 0;
      }
    }

    &-bot {
      margin: 26px 0 0 0;

      display: flex;
      justify-content: space-between;
      align-items: center;

      &-show {
        width: 211px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        @include respond-down(md) {
          width: auto;

          .link-icon__text {
            display: none;
          }

          .svg-icon {
            margin-left: 14px;
            margin-right: 0;
          }
        }
      }
    }
  }

  &_container {
    max-width: 780px;
    width: 100%;

    padding: 0 0 0 80px;

    @include respond-down(lg) {
      padding: 0 24px;
      box-sizing: border-box;
    }

    @include respond-down(md) {
      padding: 0;
    }
  }
}
</style>
